import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { InvitationList } from "@/features/organizations/components/invitation-list";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer } from "@fleet/ui";
import { canJoinAnotherOrganization } from "@space/shared";

function InvitationsPage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Invitations`)}
      description={t(
        // Tenancy mode: "and join new organizations" is redundant in
        // "single academy" mode. Watch the nuance: the FIRST invitation IS accepted
        // (that's how teaching staff join the academy), what doesn't exist is
        // belonging to several — so the phrase isn't negated, it's shortened.
        // Two whole variants, not an interpolation (i18n registry doctrine
        // de vocabulario).
        canJoinAnotherOrganization(1)
          ? msg`Manage your pending invitations and join new organizations.`
          : msg`Manage your pending invitations.`,
      )}
    >
      <PageContainer maxWidth="3xl">
        <InvitationList />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const invitationsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/invitations",
  component: InvitationsPage,
});
